import { useAuth } from '../context/authContext';
import { useDashboard } from '../context/dashboardContext';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { LoadingSpinner } from '../components/shareable/loadingModal';

const ProtectedRoute = ({ roles = [] }) => {
  const { user, isAuthenticated, loading: authLoading } = useAuth();
  const { isLoading: dashboardLoading } = useDashboard();
  const location = useLocation();

  if (authLoading || dashboardLoading) {
    return <LoadingSpinner fullPage />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check if user is trying to access home route without privilege
  if ((location.pathname === '/' || location.pathname === '/home') && 
      user?.email !== 'rrose@babsusa.com') {
    return <Navigate to="/quotes" replace />;
  }

  if (roles.length > 0 && !roles.includes(user?.role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;